import React from 'react';

interface StatItemProps {
  value: string;
  label: string;
}

const StatItem: React.FC<StatItemProps> = ({ value, label }) => (
  <div className="text-center py-2 sm:py-0">
    <div className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-accent mb-1">{value}</div>
    <div className="text-white/60 text-xs sm:text-sm font-medium uppercase tracking-wider">{label}</div>
  </div>
);

const StatsBar: React.FC = () => {
  return (
    <div className="relative py-10 sm:py-16 overflow-hidden">
      <img src="https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=2670" alt="Clean clinic room background" className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-overlay" />
      <div className="absolute inset-0 bg-primary/95" />
      <div className="container-main relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 md:gap-16 sm:divide-x sm:divide-white/20">
          <StatItem value="10+" label="Years in Business" />
          <StatItem value="3,000+" label="Products Available" />
          <StatItem value="Africa" label="Wide Distribution" />
        </div>
      </div>
    </div>
  );
};

export default StatsBar;
